import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Star } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="relative pt-12 pb-20 px-4 overflow-hidden bg-cream-50" data-id="element-109">
      {/* Background decorative blobs */}
      <div className="absolute top-[-10%] left-[-10%] w-96 h-96 bg-sage-100 rounded-full mix-blend-multiply filter blur-3xl opacity-50 animate-blob" data-id="element-110"></div>
      <div className="absolute top-[20%] right-[-10%] w-96 h-96 bg-naranja-100 rounded-full mix-blend-multiply filter blur-3xl opacity-50 animate-blob animation-delay-2000" data-id="element-111"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-112">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-113">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center lg:text-left" data-id="element-114">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.1,
            type: 'spring',
            stiffness: 200
          }} className="inline-flex items-center gap-2 bg-azul-naval-500 text-white font-bold px-5 py-2 rounded-full text-sm mb-6 shadow-md" data-id="element-115">
              <Sparkles className="w-4 h-4" data-id="element-116" />
              Para madres ocupadas
              <Sparkles className="w-4 h-4" data-id="element-117" />
            </motion.div>
            <h1 className="text-4xl md:text-5xl lg:text-[3.4rem] font-black text-azul-naval-500 leading-tight mb-6" data-id="element-118">
              ¿Domingo por la noche
              <br className="hidden md:block" data-id="element-119" /> y otra vez con{' '}
              <span className="text-naranja-500" data-id="element-120">
                pánico por
                <br className="hidden md:block" data-id="element-121" /> la lonchera
              </span>{' '}
              de mañana?
            </h1>
            <p className="text-lg md:text-xl text-charcoal-800 mb-8 leading-relaxed" data-id="element-122">
              Recupera tus mañanas y la salud de tus hijos con el sistema de
              "Base Común".{' '}
              <strong data-id="element-123">Loncheras nutritivas en menos de 10 minutos</strong>, sin
              dramas en la cocina y sin gastar una fortuna en el súper.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4" data-id="element-124">
              <CTAButton data-id="element-125">¡SÍ! QUIERO EL KIT AHORA</CTAButton>
            </div>

            <div className="mt-6 flex items-center justify-center lg:justify-start gap-2 text-sm text-charcoal-800 font-medium" data-id="element-126">
              <div className="flex gap-0.5" data-id="element-127">
                {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 text-mostaza-500 fill-mostaza-500" data-id="element-128" />)}
              </div>
              <span className="ml-1" data-id="element-129">Únete a +2,500 mamás aliviadas</span>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-130">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-white transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-131">
              <img src="https://cdn.magicpatterns.com/uploads/es8SQFiJkJ1STycXMthefQ/12.png" alt="Niños felices comiendo loncheras saludables y el Kit de Supervivencia en tablet" className="w-full h-auto object-cover" data-id="element-132" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" data-id="element-133"></div>
            </div>

            {/* Floating badge */}
            <motion.div initial={{
            y: 20,
            opacity: 0
          }} animate={{
            y: 0,
            opacity: 1
          }} transition={{
            delay: 0.8,
            duration: 0.5
          }} className="absolute -bottom-6 -left-6 bg-white p-4 rounded-2xl shadow-xl flex items-center gap-3 border border-cream-100" data-id="element-134">
              <div className="bg-sage-100 p-2 rounded-full" data-id="element-135">
                <span className="text-2xl" data-id="element-136">⏱️</span>
              </div>
              <div data-id="element-137">
                <p className="text-xs text-charcoal-600 font-bold uppercase" data-id="element-138">
                  Tiempo récord
                </p>
                <p className="text-charcoal-900 font-black text-lg" data-id="element-139">
                  Listas en 10 min
                </p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}